import ReactDOM from 'react-dom/client';
import App, { RouteType } from './App.tsx';

(() => {
  const path = window.location.pathname;
  switch (path) {
    case '/interviewee':
      ReactDOM.createRoot(document.getElementById('root')!).render(
        <App type={RouteType.INTERVIEWEE} />,
      );
      break;
    case '/interviewer':
      ReactDOM.createRoot(document.getElementById('root')!).render(
        <App type={RouteType.INTERVIEWER} />,
      );
      break;
    case '/setting':
      ReactDOM.createRoot(document.getElementById('root')!).render(
        <App type={RouteType.SETTING} />,
      );
      break;
    default:
      ReactDOM.createRoot(document.getElementById('root')!).render(
        <App type={RouteType.MAIN} />,
      );
      break;
  }
})();
